// extracted by mini-css-extract-plugin
export var contactForm = "contact-form-module--contact-form--beMJy";
export var validationMessage = "contact-form-module--validation-message--1dLJL";
export var formGroup = "contact-form-module--form-group--12_Mf";
export var error = "contact-form-module--error--1CzD9";